
// Test data for Level 1 Fairway Wood Training

export const fairwayWoodTests = [
  {
    id: "fairwayWood-3",
    title: "Bois 3",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 4 cercles de 1, 3, 5, 8 m. Taper 10 balles avec le bois 3 vers une cible à 200 m, noter les points selon la précision.",
    icon: "🏌️‍♂️"
  },
  {
    id: "fairwayWood-5",
    title: "Bois 5",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 4 cercles de 1, 3, 5, 8 m. Taper 10 balles avec le bois 5 vers une cible à 180 m, noter les points selon la précision.",
    icon: "🏌️‍♂️"
  }
];
